import { MODAL_CLOSE, MODAL_OPEN } from "./types";
import { selectors as localeSelectors } from "../locale";

export function openModal(modalType, modalProps) {
  return {
    type: MODAL_OPEN,
    modalType,
    modalProps
  };
}

export const openRedeemModal = () => (dispatch, getState) => {
  const state = getState();
  dispatch(
    openModal("RedeemModal", {
      title: localeSelectors.getString(state, "redeem.redeem-codes")
    })
  );
};

export function closeModal() {
  return {
    type: MODAL_CLOSE
  };
}
